// extracted by mini-css-extract-plugin
export var cardTitle = "_ce-1";
export var commentBubble = "_ce-e";
export var commentForm = "_ce-a";
export var commentInput = "_ce-b";
export var commentLabel = "_ce-d";
export var commentPrompt = "_ce-9";
export var csatCard = "_ce-0";
export var feedbackSection = "_ce-7";
export var starDisabled = "_ce-6";
export var starEmpty = "_ce-5";
export var starFilled = "_ce-4";
export var starWrapper = "_ce-3";
export var starsContainer = "_ce-2";
export var submittedComment = "_ce-c";
export var thankYouText = "_ce-8";